export const FALLBACK_LANGUAGE = 'fr-FR';
export const FALLBACK_MARKETPLACE = 'fr';
